import styled from 'styled-components';
import { Row, Column, constants } from '@narvar/nth-grid';

const smallBreakpoint = constants.breakpointMinWidths[constants.WIDTH_SM];

export const ActionsRow = styled(Row)`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 0;
  @media (min-width: ${smallBreakpoint}) {
    flex-direction: row;
    margin-top: 1.5rem;
  }
`;

export const CancelActionWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
  order: 2;
  margin-top: 1.5rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-top: 0;
    justify-content: flex-start;
    order: 1;
  }
`;

export const ExpandActionWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
  order: 1;
  margin-top: 1.5rem;
  @media (min-width: ${smallBreakpoint}) {
    margin-top: 0;
    order: 2;
  }
`;

export const FedexAttributionWrapper = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
  order: 3;
  margin-top: 1.5rem;
  @media (min-width: ${smallBreakpoint}) {
    justify-content: flex-end;
    margin-top: 0;
  }
`;

export const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const Item = styled.li`
  margin-bottom: 0.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`;
